import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './app/providers/ThemeProvider';
import { QueryProvider } from './app/providers/QueryProvider';
import { router } from './app/router';

// CSS load order (Tailwind v4 шилжилт дууссан, Bootstrap зайлуулсан):
//   1. bootstrap-icons.css — icon font (Bootstrap CSS бус, бие даасан).
//   2. handsontable*.css — grid theme.
//   3. tokens.css — `--ts-*` design token (theme-aware, `--bs-tertiary-bg`
//      / `--bs-body-color` гэх мэт хуучин Bootstrap variable-уудыг өөрөө
//      тогтоодог болсон тул Bootstrap CSS-гүйгээр ажиллана).
//   4. tailwind.css — `@theme` нь tokens.css-ийн variable-аар depend хийнэ.
//   5. layout.css + components.css — TseTsu custom `.ts-*` / `.if-*`
//      design system. Tailwind-аас ДАРАА load хийгдэх нь cascade-ээр давамгайлна.
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'handsontable/styles/handsontable.css';
import 'handsontable/styles/ht-theme-main.css';
import './styles/tokens.css';
import './styles/tailwind.css';
import './styles/layout.css';
import './styles/components.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <QueryProvider>
        <RouterProvider router={router} />
      </QueryProvider>
    </ThemeProvider>
  </StrictMode>,
);
